import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconToggleS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 10 4" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 3C0.223858 3 1.19063e-07 3.22386 1.31134e-07 3.5C1.43204e-07 3.77614 0.223858 4 0.5 4L9.5 4C9.77614 4 10 3.77614 10 3.5C10 3.22386 9.77614 3 9.5 3L0.5 3ZM0.5 3.93403e-07C0.223858 4.05473e-07 -1.20706e-08 0.223858 0 0.5C1.20706e-08 0.776143 0.223858 1 0.5 1L9.5 1C9.77614 1 10 0.776142 10 0.5C10 0.223858 9.77614 -1.20705e-08 9.5 0L0.5 3.93403e-07Z"
        fill="var(--color-typo-primary)"
        fillOpacity="0.3"
      />
    </svg>
  )
}

export const IconToggle = createIcon({
  l: IconToggleS,
  m: IconToggleS,
  s: IconToggleS,
  xs: IconToggleS,
  name: 'IconToggle',
})
